export const toHourMinText = (value: number) => {
  const sec = Math.floor(value / 1000)
  if (sec < 60) {
    return `${sec}초`
  }

  const min = Math.floor(sec / 60)
  if (min <= 60) {
    const secs = sec % 60
    return `${min}분 ${secs}초`
  } else {
    const hours = Math.floor(min / 60)
    const mins = min % 60
    return `${hours}시간 ${mins}분`
  }
}
